import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { WiTime4 } from 'react-icons/wi';
import {
  clearWSSConnections,
  getCDNInfo,
  getMultiLiveStreamLoader,
  getShowTryAgainScreen,
  getWSSConnections,
  setIsReloadedStream,
  setMultiLiveStreamLoader,
  setShowTryAgainScreen,
  setWSSConnection,
} from '../../../store/reducers/StreamingReducer';
import { setDeviceInformation } from '../../../store/reducers/AccountReducer';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HiOutlineVideoCamera } from 'react-icons/hi2';
import { FiSettings } from 'react-icons/fi';
import LoadingCamera from './LoadingCamera';
import { Utils, constants } from '../../../helpers';
import { ReactComponent as ThreeDotIcon } from '../../../assets/images/VerticalThreeDots.svg';
import useEventsStore from '../../../store/EventsStore';
import { getNoPlaybackContentAvailable } from '../../../store/reducers/ViewsReducer';
import NoVideoContent from './NoVideoContent';
import { usePoliciesStore } from '../../../store/policiesStore';
import ImageGridLoading from './ImageGridLoading';
import { ReactComponent as CloudDownloadOff } from '../../../assets/images/CloudDownloadOff.svg';
import ImageGridItem from './ImageGridItem';
import { sendCloudDisConnectRequest } from '../../../utils/webRTC/multi-cloud-playback-handler';
import { stopPlaybackConnection } from '../../../utils/webRTC/multi-edge-playback-handler';
import NoContentScreen from './NoContentScreen';

const PlaybackGridItem = ({
  deviceId,
  layout,
  device,
  activeTime = new Date(),
  timeZone,
  isNoVideoContent,
  cdnValue,
  selectedEventTime,
  cvrSnapMode,
  handlePausePlayPlayback,
}) => {
  const hideLoaderRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cdnInfo = useSelector(getCDNInfo);
  const noPlaybackAvailableList = useSelector(getNoPlaybackContentAvailable);
  const wssConnections = useSelector(getWSSConnections);
  const [isNoPlaybackAvailable, setIsNoPlaybackAvailable] = useState(false);
  const [loading, setLoading] = useState();
  const { setSelectedEventStore, setEventCVRMode, setPauseVideo } =
    useEventsStore();
  const { getLoggedInUserPolicies } = usePoliciesStore();
  const userPolicies = getLoggedInUserPolicies();
  const [showTryAgain, setShowTryAgain] = useState(false);
  const [currentDevice, setCurrentDevice] = useState(device);
  const loaderData = useSelector(getMultiLiveStreamLoader);
  const tryAgainData = useSelector(getShowTryAgainScreen);

  useEffect(() => {
    if (
      tryAgainData &&
      Object.keys(tryAgainData)?.length > 0 &&
      tryAgainData?.[deviceId]
    ) {
      setShowTryAgain(!!tryAgainData?.[deviceId]);
      clearTimeout(hideLoaderRef.current);
    } else {
      if (showTryAgain) setShowTryAgain(false);
    }
  }, [tryAgainData?.[deviceId]]);

  useEffect(() => {
    if (loaderData && Object.keys(loaderData)?.length === 0) {
      setLoading(true);
      startStopLoader(true);
      callTimeoutLoader();
    }
  }, [JSON.stringify(loaderData)]);

  useEffect(() => {
    if (loaderData && Object.keys(loaderData)?.length > 0) {
      setLoading(loaderData?.[deviceId]);
      if (!loading && loaderData?.[deviceId]) {
        callTimeoutLoader();
      } else {
        if (loading && loaderData?.[deviceId] === false) {
          clearTimeout(hideLoaderRef.current);
        }
      }
    }
  }, [JSON.stringify(loaderData?.[deviceId])]);

  useEffect(() => {
    if (noPlaybackAvailableList?.length > 0) {
      setIsNoPlaybackAvailable(noPlaybackAvailableList.includes(deviceId));
    } else {
      setIsNoPlaybackAvailable(false);
    }
  }, [noPlaybackAvailableList]);

  useEffect(() => {
    getCapabiltiesForDevice(device);

    return () => {
      clearTimeout(hideLoaderRef.current);
    };
  }, [JSON.stringify(device)]);

  const callTimeoutLoader = () => {
    clearTimeout(hideLoaderRef.current);
    hideLoaderRef.current = setTimeout(() => {
      startStopLoader(false);
      dispatch(setShowTryAgainScreen({ deviceId: deviceId, isShow: true }));
    }, 60000);
  };

  const startStopLoader = (isLoading) => {
    const loaderObj = {
      deviceId,
      isLoading,
    };
    dispatch(setMultiLiveStreamLoader(loaderObj));
  };

  const getCapabiltiesForDevice = async (deviceData) => {
    if (deviceData?.capability) {
      try {
        const response = await fetch(deviceData?.capability?.url);
        if (response.status === 200) {
          const responseJson = await response.json();
          setCurrentDevice({ ...deviceData, capDetails: responseJson });
        } else {
          setCurrentDevice(deviceData);
        }
      } catch (error) {
        setCurrentDevice(deviceData);
      }
    } else {
      setCurrentDevice(deviceData);
    }
  };

  const OnClickCameraDetails = async () => {
    if (wssConnections) {
      Object.keys(wssConnections).forEach((key) => {
        sendCloudDisConnectRequest(key);
        stopPlaybackConnection(key);
      });
    }
    dispatch(clearWSSConnections());
    dispatch(setIsReloadedStream(false));
    dispatch(setWSSConnection(false));
    // dispatch(setDeviceInformation(currentDevice));
    await setSelectedEventStore(Utils.getUnixDate(activeTime) * 1000);
    await setEventCVRMode(true);
    if (cvrSnapMode) {
      setPauseVideo(true);
    }
    navigate(`/cameras/dashboard.html`, {
      state: {
        id: deviceId,
        cdnInfo: cdnInfo ? cdnInfo : {},
        origin: 'multiview-contextual-menu',
      },
    });
  };

  const OnClickCameraSettings = () => {
    dispatch(setDeviceInformation(currentDevice));
    deviceId && navigate(`/devices/dashboard.html?deviceId=${deviceId}`);
  };

  const handleTryAgain = () => {
    startStopLoader(true);
    setLoading(true);
    dispatch(setShowTryAgainScreen({ deviceId: deviceId, isShow: false }));
    setShowTryAgain(false);
    setTimeout(() => {
      handlePausePlayPlayback('play', null, deviceId);
    }, 500);
    callTimeoutLoader();
  };

  const handleDoubleClick = () => {
    OnClickCameraDetails();
  };

  const isBufferAvailable = () => {
    try {
      const playbackPlayer = document.getElementById(
        `playback-video${deviceId}`,
      );
      const currentTime = Utils.getUnixDate(
        activeTime || Utils.getDate(playbackPlayer?.currentTime),
      );
      const bufferStartTime =
        playbackPlayer?.mediaSource?.activeSourceBuffers?.[0]?.buffered?.start(
          0,
        );
      const bufferEndTime =
        playbackPlayer?.mediaSource?.activeSourceBuffers?.[0]?.buffered?.end(0);
      const checkBufferRange =
        currentTime >= bufferStartTime && currentTime <= bufferEndTime;
      return checkBufferRange;
    } catch (err) {}
  };

  return (
    <>
      {loading && (
        <div className="playback-grid-snapshot-div">
          <ImageGridLoading
            deviceId={deviceId}
            time={activeTime}
            cdnValue={cdnValue}
            timeZone={timeZone}
            selectedEventTime={selectedEventTime}
          />
          <LoadingCamera />
        </div>
      )}
      {!loading && !isBufferAvailable() && cvrSnapMode && (
        <ImageGridItem
          key={deviceId}
          layout={deviceId}
          device={device}
          deviceId={deviceId}
          moveTimeline={false}
          liveSnapshot={false}
          time={activeTime}
          cdnValue={cdnValue}
          camera={true}
          timeZone={timeZone}
          snapshotImages={null}
          imageURL={null}
          selectedEventTime={selectedEventTime}
        />
      )}
      {!loading && showTryAgain && !cvrSnapMode ? (
        <NoContentScreen
          deviceId={deviceId}
          device={device}
          activeTime={activeTime}
          timeZone={timeZone}
          onTryAgain={handleTryAgain}
        />
      ) : isNoVideoContent || isNoPlaybackAvailable ? (
        <NoVideoContent
          deviceId={deviceId}
          device={currentDevice}
          activeTime={activeTime}
          timeZone={timeZone}
        />
      ) : (
        <>
          <>
            <div
              className={`device-overlay hovered`}
              onDoubleClick={(e) => {
                e.stopPropagation();
                handleDoubleClick();
              }}
            >
              <div className="device-title-container">
                <div className="device-name">{device?.deviceName}</div>
                <div className="device-location">
                  {device?.locationName} • {device?.areaName}
                </div>
              </div>
              <div className="date-time-wrapper">
                <div className="date-time">
                  <WiTime4 size={14} />
                  {moment
                    .tz(moment(activeTime), timeZone)
                    .format('hh:mm:ss A z')}
                </div>
              </div>
              <div className="menu-icon">
                <NavDropdown
                  className="devices-dropdown"
                  title={<ThreeDotIcon />}
                >
                  <NavDropdown.Item
                    className="devices-dropdown-options"
                    onClick={(e) => {
                      e.stopPropagation();
                      OnClickCameraDetails();
                    }}
                  >
                    <HiOutlineVideoCamera size={16} />
                    <span className="devices-dropdown-options-label">
                      {constants.CAMERAS_VIDEO_CAMERA_DETAILS_LABEL}
                    </span>
                  </NavDropdown.Item>
                  {userPolicies.view_device_settings && (
                    <NavDropdown.Item
                      className="devices-dropdown-options"
                      onClick={(e) => {
                        e.stopPropagation();
                        OnClickCameraSettings();
                      }}
                    >
                      <FiSettings size={14} />
                      <span className="devices-dropdown-options-label">
                        {constants.CAMERAS_VIDEO_SETTINGS_LABEL}
                      </span>
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              </div>
            </div>
            {/* <div className="primary-circle"></div> */}
            <div
              id={`remote-view-wrapper${layout}`}
              className="streaming-container"
            >
              {/* <video
                id={`video${layout}`}
                width="764"
                height="450"
                ref={remoteVideoRef}
                autoPlay={true}
                playsInline={true}
                muted={true}
              />*/}
              <canvas id={`canvas${layout}`} className="d-none" />
              <div id={`noVideo${layout}`} className="no-video-edge-ui">
                <CloudDownloadOff height="40" width="40" />
                <span className="no-video-edge-text">
                  {constants.PLAYBACK_NO_VIDEO_TEXT}
                </span>
              </div>
            </div>
          </>
          <>
            {/* {!loading && !remoteStream?.active && (
              <NoVideoContent
                deviceId={deviceId}
                device={device}
                activeTime={activeTime}
                timeZone={timeZone}
              />
            )} */}
          </>
        </>
      )}
    </>
  );
};

export default PlaybackGridItem;
